import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "pms-page-datagrid-column-button",
  template: "",
  standalone: false
})
export class PageDatagridColumnButtonComponent {
  @Input() icon!: string;
  @Input() name!: string;
  @Input() disabled: ((data: any) => boolean) | null = null;

  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();
}
